'use client'

import { SLIDER_CLASS_NAME } from '@/constants'
import s from './supplier-review-item.module.scss'

import cx from 'classnames'
import { StartFilledIcon } from '@/components/svg/star-filled-icon/star-filled-icon'
import { useClampToggle } from '@/hooks/use-clamp-toggle'

type Props = {
  name: string
  message: string
  rating?: number
  date?: string
}

export const SupplierReviewItem = ({ name, message, rating, date }: Props) => {
  const { ref: messageRef, isClamped, isOpen, toggle } = useClampToggle()

  return (
    <div className={cx(SLIDER_CLASS_NAME, s.reviewContainer)}>
      <div>
        <h3 className={s.name}>{name}</h3>
        {rating && date && (
          <div className={s.dateAndRatingContainer}>
            <div className={s.ratingContainer}>
              <StartFilledIcon fill="#131313" width={14} height={14} />
              <p className={s.rating}>{rating.toFixed(1)}</p>
            </div>
            <p className={s.date}>{date}</p>
          </div>
        )}
      </div>
      <p
        ref={messageRef}
        className={cx(s.message, {
          [s.messageOpen]: isOpen,
        })}
      >
        {message}
      </p>
      <div className={s.buttonContainer}>
        {isClamped && (
          <button
            type="button"
            className={s.clampButton}
            onClick={toggle}
            aria-expanded={isOpen}
          >
            {isOpen ? 'Read less' : 'Read more'}
          </button>
        )}
      </div>
    </div>
  )
}
